import { StyleSheet, Text, View } from '@react-pdf/renderer';

interface TablePageFooterProps {}

const TablePageFooter = ({}: TablePageFooterProps) => {
  return (
    <View style={styles.container}>
      <Text style={styles.copyright}>© All Rights Reserved SkyHop Global 2025</Text>
      <Text style={styles.pageFooterLeft} />
      <Text style={styles.pageFooterRight} />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    height: 32,
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    borderTop: '1px solid #D9D9D9',
  },
  pageFooterLeft: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: 77,
    height: 5,
    backgroundColor: '#FF9E16',
  },
  pageFooterRight: {
    position: 'absolute',
    top: 0,
    right: 0,
    width: 77,
    height: 5,
    backgroundColor: '#40ADE2',
  },
  copyright: {
    fontSize: 9,
    fontWeight: 'bold',
    textAlign: 'center',
    textTransform: 'capitalize',
  },
});

export default TablePageFooter;
